<template>
  <div class="login container">
    <div v-if="!redeemTicketPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else>

      <p class="small-header-text pt-5">Ticket code</p>
      <h2>{{ticket.ticket_reference}}</h2>
      <div class="spacer"></div>

      <p class="large-header-text mt-4">Ticket redeemed!</p>

      <div class="row d-flex justify-content-center">
        <cta link="home" type="submit" text="Finish" :loading="submitted" />
      </div>

    </form>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Login',
  components: {
  },
  inject: ['$validator'],
  data : function(){       
      return {
        ticket_reference: '',
        submitted     : false,
        error:'',
        destroyed: false
      };

  },

  computed: {

    account(){
      return this.$store.getters.getAccount;
    },
    
    ticket() {
      return this.$store.getters.getTicket;
    },

    /**
     * Format the local time into a string
     */
    ticket_local_time() {
      let time = moment(this.ticket.EventSlot.local_time, "HH:mm:ss").format('H:mma');
      return time;
    },

    /**
     * Format the event date into a string
     */
    ticket_date() {
      let date = moment(this.ticket.event_datetime).format('Do MMMM YYYY');
      return date;
    },

    /**
     * Match up ticket unit_id with the name of the unit
     */
    ticket_location() {
      let ticket_unit = this.ticket.unit_id;
      let allUnits = this.ticket.Product.TicketProductConfig.Units;
      let location = allUnits.filter(unit => unit.id == ticket_unit)[0].name;
      return location;
    }
 
  },
  methods:{

  }
}
</script>

<style scoped>
.loader {
  position: absolute;
}

.small-header-text {
  font-size: 1.3em;
  margin: 0;
}

.medium-header-text {
  font-size: 1.6em;
  margin: 0;
}

.large-header-text {
  font-size: 2.7em;
}

.spacer {
  height: 1em;
}

.ticket-cta-container {
  column-gap: 4em;
}
</style>